import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "COLOR_FORM";
export const ColorFormAction = createFormAction(FORM_KEY);
